import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view-schedule',
  templateUrl: './view-schedule.component.html',
  styleUrls: ['./view-schedule.component.css']
})
export class ViewScheduleComponent implements OnInit {
  eventName: string;
  seasonPreview: any;
  loading: boolean;
  imageURL = environment.URL_TEAM_IMAGES;
  teamDescription: any;
  teamName: any;
  teamImage: any;
  vendorId: any;

  constructor(
    public dialogRef: MatDialogRef<ViewScheduleComponent>,
    private inventoryService: SsInventoryService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.eventName = data.eventName;
    this.teamImage = data.teamImage;
    this.teamName = data.teamName;
    this.teamDescription = data.teamDescription;
    this.vendorId = data.vendorId;
  }

  ngOnInit() {
    if (this.vendorId && this.vendorId === '2') {
      // TICKETS DOT COM
      this.inventoryService.getJSON().subscribe(data => {
        this.seasonPreview = data.gameEvents;
        _.each(this.seasonPreview, (value) => {
          value.team_thumb_img = 'ss-leagues/NBA/charlotte-hornets.png';
          if (value.event_time === '00:00' || value.event_time === 'TBA' || value.event_time === 'TBD') {
            value.event_time = 'TBD';
          } else {
            value.event_time = moment(value.event_time, 'hh:mm').format('LT');
          }
          value.event_date = moment(value.event_date).format('dddd, MMMM Do, YYYY');
        });
      });
    } else {
      // TM
      this.inventoryService.getSeasonPreview(this.eventName).subscribe(res => {
        this.loading = false;
        this.seasonPreview = res.season_preview;
        _.each(this.seasonPreview, (value) => {
          if (value.event_time === '00:00' || value.event_time === 'TBA' || value.event_time === 'TBD') {
            // Display TDB if invalid date
            value.event_time = 'TBD';
          } else {
            value.event_time = moment(value.event_time, 'hh:mm').format('LT');
          }
          value.event_date = moment(value.event_date).format('dddd, MMMM Do, YYYY');
        });
      },
        (err) => {
          this.loading = false;
          this.dialogRef.close();
        });
    }
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/view-schedule/view-schedule.component.ts